export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const LOAD_LOOKUP_LISTS_SUCCESS = "LOAD_LOOKUP_LISTS_SUCCESS";
export const LOAD_VEHICLE_TYPES_SUCCESS = "LOAD_VEHICLE_TYPES_SUCCESS";
export const LOAD_RESERVATION_TYPES_SUCCESS = "LOAD_RESERVATION_TYPES_SUCCESS";
export const LOAD_INSURANCE_COMPANIES_SUCCESS = "LOAD_INSURANCE_COMPANIES_SUCCESS";
export const LOAD_LEASING_COMPANIES_SUCCESS = "LOAD_LEASING_COMPANIES_SUCCESS";
